import { Card, CardContent } from "@mui/material";
import { FC } from "react";
import { MetricsDateRangeFilter } from "pages/Metrics/components/MetricsDateRangeFilter";
import { MetricsDateRange } from "pages/Metrics/metricsDateRange";

type Props = {
  value: MetricsDateRange;
  onChange: (value: MetricsDateRange) => void;
};

export const HomeFeedbackPeriodCard: FC<Props> = ({ value, onChange }) => (
  <Card sx={{ overflow: "visible" }}>
    <CardContent
      sx={{
        overflow: "visible",
        pt: { xs: 3, sm: 2 },
        pb: { xs: 2, sm: 2 },
        "&:last-child": { pb: { xs: 2, sm: 2 } },
      }}
    >
      <MetricsDateRangeFilter value={value} onChange={onChange} fullWidth />
    </CardContent>
  </Card>
);
